import {createSelector} from 'reselect';
import getValidationErrorsFromModelState from '../shared/services/getValidationErrorsFromModelState';

const getEditUserModalModelState = state => state.features.users.modals.editUser.get('modelState');
export const getEditUserModalValidationErrors = createSelector(
  getEditUserModalModelState,
  modelState => getValidationErrorsFromModelState(modelState));

const getSetUserPasswordModalModelState = state => state.features.users.modals.setUserPassword.get('modelState');
export const getSetUserPasswordModalValidationErrors = createSelector(
  getSetUserPasswordModalModelState,
  modelState => getValidationErrorsFromModelState(modelState));



// WEBPACK FOOTER //
// ./app/features/users/selectors.js